@include host-component-properties;

:host {
  --paf-result-row-footer-font-size: 16;
  --paf-result-row-footer-cus-him-icons-column-gap: 3;
  --paf-result-row-footer-cus-him-icons-row-gap: 3;
  --paf-result-row-footer-cus-him-icons-size: 16;
  --paf-result-row-footer-sections-gap: var(--paf-global-spacing-fixed-2x);
  --paf-result-row-footer-row-gap: var(--paf-global-spacing-fixed-3x);

  @include mq($from: small) {
    --paf-result-row-footer-cus-him-icons-size: 20;
  }
}

.result-row-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: px-to-rem(var(--paf-result-row-footer-sections-gap));
  row-gap: px-to-rem(var(--paf-result-row-footer-row-gap));
  justify-content: space-between;
  position: relative;
  font-size: px-to-rem(var(--paf-result-timetable-row-font-size, var(--paf-result-row-footer-font-size)));

  &.loading * {
    opacity: 0;
  }

  .loader {
    @include skeleton-loading;

    right: 30%;
  }

  .platform {
    flex-grow: 1;
    font-size: inherit;

    &.platform-changed {
      color: var(--paf-global-post-alert);
    }
  }

  .platform + .cus-him-icons:not(:empty) {
    flex-grow: 1;
  }

  & .occupancy {
    display: flex;
    justify-content: center;
    flex-shrink: 1;
    flex-grow: 1;

    &:first-child {
      justify-content: flex-start;
    }
  }

  & .cus-him-icons,
  & .attribute-icons {
    display: flex;
    flex-wrap: wrap;
    column-gap: px-to-rem(var(--paf-result-row-footer-cus-him-icons-column-gap));
    row-gap: px-to-rem(var(--paf-result-row-footer-cus-him-icons-row-gap));
  }

  & .cus-him-icons {
    flex-shrink: 0;
    flex-grow: 1;
    min-width: px-to-rem(var(--paf-result-row-footer-cus-him-icons-size));
    justify-content: flex-end;
  }

  & .attribute-icons {
    flex-grow: 1;
    justify-content: center;
  }

  .attribute-icons:first-child + .cus-him-icons {
    flex-grow: 0;
  }

  & .duration {
    flex-shrink: 0;
    font-size: inherit;
  }
}
